/** Build left | aisle | right seat banks from API seats (rowIndex / columnIndex). */
export function buildSeatGrid(seats = []) {
  if (!seats.length) {
    return { leftCols: [], rightCols: [], rows: [] };
  }

  const normalized = seats.map((s) => ({
    label: String(s.label ?? ''),
    row: Number(s.rowIndex ?? s.row ?? 0),
    columnIndex: Number(s.columnIndex ?? 0),
    occupied: s.available === false || s.occupied === true,
  }));

  const byRow = new Map();
  for (const s of normalized) {
    if (!byRow.has(s.row)) byRow.set(s.row, []);
    byRow.get(s.row).push(s);
  }
  const rowKeys = [...byRow.keys()].sort((a, b) => a - b);
  const rowCount = rowKeys.length;

  const colFreq = new Map();
  for (const s of normalized) {
    colFreq.set(s.columnIndex, (colFreq.get(s.columnIndex) || 0) + 1);
  }

  const threshold = Math.ceil(rowCount * 0.5);
  const mainCols = [...colFreq.keys()]
    .filter((c) => colFreq.get(c) >= threshold)
    .sort((a, b) => a - b);
  const aisleCols = [...colFreq.keys()]
    .filter((c) => colFreq.get(c) < threshold)
    .sort((a, b) => a - b);

  let aisleAfter = Math.floor(mainCols.length / 2) - 1;
  let bestGap = -1;
  for (let i = 0; i < mainCols.length - 1; i += 1) {
    const gap = mainCols[i + 1] - mainCols[i];
    if (gap > bestGap) {
      bestGap = gap;
      aisleAfter = i;
    }
  }
  if (bestGap <= 1 && mainCols.length >= 4) {
    aisleAfter = Math.floor(mainCols.length / 2) - 1;
  }
  if (aisleAfter < 0) aisleAfter = 0;

  const leftCols = mainCols.slice(0, aisleAfter + 1);
  const rightCols = mainCols.slice(aisleAfter + 1);

  const rows = rowKeys.map((r) => {
    const list = byRow.get(r) || [];
    const at = (c) => list.find((s) => s.columnIndex === c) || null;
    let aisle = null;
    for (const c of aisleCols) {
      aisle = at(c);
      if (aisle) break;
    }
    return {
      left: leftCols.map(at),
      aisle,
      right: rightCols.map(at),
    };
  });

  return { leftCols, rightCols, rows };
}
